import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { decryptURL } from 'utils/functions';
import { IntegracaoContext } from 'contexts/IntegracaoContext';
import { logos } from 'assets/integracoes';
import Blank from 'assets/blank.png';
import Amazon from './Amazon';
import GptMaker from './GptMaker';
import IncubadoraE from './IncubadoraE';
import IncubadoraR from './IncubadoraR';
import Kwai from './Kwai';
import MadeiraMadeira from './MadeiraMadeira';
import Magalu from './Magalu';
import MercadoLivre from './MercadoLivre';
import Shein from './Shein';
import Shopee from './Shopee';
import Tiktok from './Tiktok';
import Whatsapp from './Whatsapp';

const Manutenção = () => {
  const { hash } = useParams();
  const decrypt = decryptURL(hash);
  const [integracao, setIntegracao] = useState(null);
  const { getAuthURL, getLoading, postIntegracao, postLoading } =
    useContext(IntegracaoContext);
  const loading = getLoading || postLoading;
  const nome_logo = integracao?.api?.replace(/\s+/g, '');
  const logo = logos?.[nome_logo] ?? Blank;

  useEffect(() => {
    setIntegracao(decrypt);
  }, []);

  const handleAuth = ({ token, seller_id }) => {
    const hasParams = Boolean(token) || Boolean(seller_id);
    const integracao_id = integracao?.id;
    const integracao_api = integracao?.api;

    if (hasParams) {
      const params = { token, seller_id };
      return getAuthURL({ params, integracao_id, integracao_api });
    }

    const result = window.confirm(
      `Antes de continuar, garanta que você já está autenticado no site com a conta que deseja adicionar`
    );

    if (result) {
      const cb = (url) => url && window.open(url, '_blank');
      getAuthURL({ integracao_id, integracao_api, cb });
    }
  };

  const handleSave = (data) => {
    postIntegracao({ data });
  };

  const props = { integracao, logo, loading, handleAuth, handleSave };

  switch (integracao?.api) {
    case 'AMAZON':
      return <Amazon {...props} />;
    case 'GPTMAKER':
      return <GptMaker {...props} />;
    case 'INCUBADORA_E':
      return <IncubadoraE {...props} />;
    case 'INCUBADORA_R':
      return <IncubadoraR {...props} />;
    case 'KWAI':
      return <Kwai {...props} />;
    case 'MADEIRA MADEIRA':
      return <MadeiraMadeira {...props} />;
    case 'MAGAZINE LUIZA':
      return <Magalu {...props} />;
    case 'MERCADO LIVRE':
      return <MercadoLivre {...props} />;
    case 'SHEIN':
      return <Shein {...props} />;
    case 'SHOPEE':
      return <Shopee {...props} />;
    case 'TIKTOK':
      return <Tiktok {...props} />;
    case 'WHATSAPP':
      return <Whatsapp key={integracao.id} {...props} />;

    default:
      return null;
  }
};

export default Manutenção;
